import React from 'react';
import { KlyxFeed } from '../dashboard/components';
import { CreatePostFAB } from '@/components/Post';
import './Feed.scss';

/**
 * Feed Page
 * Dedicated page for the content feed
 * Feed data is fetched lazily by KlyxFeed component based on active tab
 */
const FeedPage: React.FC = () => {
  return (
    <div className="feed-page">
      <div className="feed-container">
        <KlyxFeed />
      </div>
      <CreatePostFAB />
    </div>
  );
};

export default FeedPage;
